import { Button, Heading, Icon, IconType } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { selfServeConstants } from 'locale/selfServe'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

type Props = {
  onClick?: () => void
}

export const GreatJobStepCard: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation(NAMESPACE.SELF_SERVE)

  return (
    <CardWrapper>
      <Icon
        customIcon={IconType.PinkCheck}
        style={{
          width: 57,
          height: 41,
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: 20,
          marginTop: 10
        }}
      />
      <StyledHeading level={4}>
        {t(selfServeConstants.GREAT_JOB_STEP_TITLE)}
      </StyledHeading>
      <InnerWrapper>
        <StyledHeadingDesc level={5}>
          {t(selfServeConstants.GREAT_JOB_STEP_DESC)}
          <Link to="/help">
            <StyledHeadingDescLink level={5}>
              {t(selfServeConstants.HELP_CENTRE)}
            </StyledHeadingDescLink>
          </Link>
        </StyledHeadingDesc>
      </InnerWrapper>
      <FooterWrapper>
        <StyledText level={1}>{t(selfServeConstants.COMPLETED)}</StyledText>
        <StyledButton variant="popout" onClick={onClick}>
          {t(selfServeConstants.CLOSE)}
        </StyledButton>
      </FooterWrapper>
    </CardWrapper>
  )
}

const CardWrapper = styled.div`
  background-color: #fff8fa;
  padding: 18px;
  border-radius: 20px;
  margin-top: 18px;
  min-height: 280px;
  display: flex;
  flex-direction: column;
`

const FooterWrapper = styled.div`
  display: flex;
  margin-top: auto;
  align-items: center;
`

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.status.popout};
  margin-bottom: 5px;
  text-align: center;
`

const StyledHeadingDesc = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
  text-align: center;
`

const StyledHeadingDescLink = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
  text-decoration: underline;
  cursor: pointer;
  text-align: center;
`

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.status.popout};
  margin-left: auto;
  margin-right: 0px;
`

const StyledButton = styled(Button)`
  margin-bottom: 0px;
  width: fit-content;
  margin-left: 15px;
`
